var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-footer-container", class: _vm.style() },
    [
      _c(
        "div",
        { staticClass: "item-detail-info-action" },
        [
          !_vm.getBundle
            ? _c("div", { staticClass: "item-detail-info-action-secondary" }, [
                _c(
                  "div",
                  { staticClass: "item-action-quantity-wrapper" },
                  [
                    _c("BaseQuantityButtons", {
                      attrs: {
                        quantity: _vm.quantity,
                        settings: { item: _vm.cartItem }
                      },
                      on: {
                        incrementQuantity: function($event) {
                          return _vm.increment()
                        },
                        decrementQuantity: function($event) {
                          return _vm.decrement()
                        },
                        setInputQuantity: _vm.setQuantityFromInput
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "BaseButton",
            {
              attrs: {
                title: "",
                ariaLabel: _vm.ariaLabelAddToCart,
                classNames: _vm.addToCartButtonClasses(),
                animated: _vm.animateButtonEnabled()
              },
              on: { afterAnimation: _vm.afterAddToCart },
              nativeOn: {
                click: function($event) {
                  return _vm.addToOrder()
                }
              }
            },
            [
              _c("div", { staticClass: "button-label-container" }, [
                _c("span", { staticClass: "button-label truncate" }, [
                  _vm._v(_vm._s(_vm.addToOrderButtonTitle()))
                ]),
                _vm._v(" "),
                !_vm._isOutOfStock
                  ? _c("span", { staticClass: "button-label" }, [
                      _vm._v("$" + _vm._s(_vm.displayFormattedPrice))
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-112df3d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112df3d9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ItemDetailActions.vue
// module id = null
// module chunks = 